import { Component } from '@angular/core';

import { GlobalHeroComponent } from '../../shared/components/global-hero/global-hero.component';
import { FormComponent } from './form/form.component';
import { KnowledgeSectionComponent } from './knowledge-section/knowledge-section.component';

@Component({
  selector: '[sign-up]',
  imports: [GlobalHeroComponent, FormComponent, KnowledgeSectionComponent],
  templateUrl: './sign-up.component.html',
  styleUrl: './sign-up.component.scss',
})
export class SignUpComponent {
  heroData = {
    backgroundImageDesktop: 'hero-sign-up',
    titleText: 'SIGN UP FOR <br class="d-none d-lg-block">',
    bodyTextDesktopWidth: '',
    titleColorText: 'UPDATES',
    bodyText:
      'Want to learn more before you’re ready to screen? We have you covered.',
    sillHouetteImage: 'hero-sillhouette-sign-up',
    sillhouette: {
      mobile: {
        width: 295,
        top: 8,
        left: 48,
      },
      tablet: {
        width: 244,
        top: 8,
        left: 96,
      },
      desktop: {
        width: 458,
        height: 327,
        top: 15,
        left: 181,
      },
    },
    sillhouetteAlt: 'A father and son playing basketball',
    altText: ' '
  };
}
